import type { RefObject } from 'preact';
import { useLayoutEffect } from 'preact/hooks';

/**
 * The HTML `<dialog>` element can be displayed using either `.show()` or `.showModal()`.
 *
 * By default, when using the `open` attribute directly, it behaves like `.show()`,
 * which means the `::backdrop` pseudo-element is not applied. To enable the native
 * backdrop and related behaviors, the dialog must be opened using `.showModal()`.
 *
 * In React (or Preact), this hook is necessary to ensure the dialog opens correctly
 * with modal behavior.
 */
export default function useOpenDialogAsModal(
  dialogRef: RefObject<HTMLDialogElement>,
  isOpen: boolean
) {
  useLayoutEffect(() => {
    if (isOpen) dialogRef.current?.showModal();
  }, [isOpen]);
}
